import { zonedDate } from "@playbrain/config/date"

/**
 * Publish dates are stored in UTC but the archive is a Japanese company's, and
 * the original site dates its posts in Tokyo time.
 */
const PUBLISH_TIMEZONE = "Asia/Tokyo"

/**
 * The live site writes English month names in both locales, so the format does
 * not vary by locale — only the timezone is fixed.
 */
export function playdataPublishDate(value: string | null | undefined): string {
  return zonedDate(value, PUBLISH_TIMEZONE, "MMMM D, YYYY")
}
